export default __webpack_public_path__ + "static/media/avatar.f8a657ed.jpg";